// Define constants events
export const EVENTS = {
    SHOPIFY_CLOSED_FAILURE: 'Closing Failed',
   };
   
    